import AnimatedSection from '../../../components/base/AnimatedSection';

const features = [
  {
    id: 1,
    title: '企业微信集成',
    description: '对接企业微信开放平台，支持消息收发、群机器人、事件回调与基础通讯录同步',
    icon: 'ri-wechat-line',
    gradient: 'from-green-500 to-emerald-600'
  },
  {
    id: 2,
    title: '飞书集成',
    description: '对接飞书开放平台，支持消息收发、事件订阅与交互卡片，用于流程触发与表单式交互',
    icon: 'ri-message-3-line',
    gradient: 'from-blue-500 to-indigo-600'
  },
  {
    id: 3,
    title: '钉钉集成',
    description: '对接钉钉开放平台，支持机器人消息、事件回调与组织架构相关能力，适配企业协作与通知场景',
    icon: 'ri-chat-4-line',
    gradient: 'from-cyan-500 to-blue-600'
  },
  {
    id: 4,
    title: '微信公众号集成',
    description: '对接微信公众平台，支持订阅消息与客服消息，适配对外服务与运营通知',
    icon: 'ri-wechat-2-line',
    gradient: 'from-teal-500 to-cyan-600'
  },
  {
    id: 5,
    title: '微信小程序集成',
    description: '对接微信小程序，支持轻量入口与业务页面承载，可从对话跳转至任务处理与信息查询',
    icon: 'ri-mini-program-line',
    gradient: 'from-emerald-500 to-teal-600'
  },
  {
    id: 6,
    title: '短信与语音通知',
    description: '对接国内短信与语音服务，用于关键告警、验证与重要通知的兜底通道',
    icon: 'ri-phone-line',
    gradient: 'from-indigo-500 to-purple-600'
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-24 bg-gradient-to-b from-slate-900 to-slate-800">
      <div className="max-w-7xl mx-auto px-6">
        <AnimatedSection animation="fadeUp" className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-cyan-500/10 backdrop-blur-sm rounded-full text-cyan-400 mb-6 border border-cyan-500/30">
            <i className="ri-apps-line"></i>
            <span className="text-sm font-semibold">核心功能</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
            全渠道消息接入
          </h2>
          <p className="text-base sm:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            支持企业微信、飞书、钉钉、微信生态等主流平台，一站式接入所有消息渠道
          </p>
        </AnimatedSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
          {features.map((feature, index) => (
            <AnimatedSection key={feature.id} animation="fadeUp" delay={index * 100}>
              <div className="group bg-slate-800/50 backdrop-blur-sm rounded-2xl p-5 sm:p-8 border border-slate-700 hover:border-cyan-500/50 transition-all duration-500 hover:shadow-xl hover:shadow-cyan-500/20 hover:-translate-y-2">
                <div className={`w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br ${feature.gradient} rounded-xl flex items-center justify-center mb-4 sm:mb-6 shadow-lg shadow-cyan-500/30 group-hover:scale-110 transition-transform duration-500`}>
                  <i className={`${feature.icon} text-2xl sm:text-3xl text-white`}></i>
                </div>
                
                <h3 className="text-lg sm:text-2xl font-bold text-white mb-2 sm:mb-4 group-hover:text-cyan-400 transition-colors">
                  {feature.title}
                </h3>
                
                <p className="text-gray-400 leading-relaxed text-sm">
                  {feature.description}
                </p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}